module.exports = __webpack_public_path__ + "img/summary-5.14d61b3d.svg";